import Component from './component'
import { compose, withProps } from 'recompose'
import withAgentStatus from 'components/withAgentStatus'

const resolveUnifiedStatus = ({
  isActive,
  limitNumChatsEnabled,
  isUserAtConversationLimit,
}) => {
  if (limitNumChatsEnabled && isUserAtConversationLimit && isActive) {
    return 'chat_limit'
  }

  if (isActive) {
    return 'available'
  }

  return 'away'
}


export default compose(
  withAgentStatus,
  withProps(({
    isActive,
    limitNumChatsEnabled,
    isUserAtConversationLimit,
  }) => ({
    agentStatus: resolveUnifiedStatus({
      isActive,
      limitNumChatsEnabled,
      isUserAtConversationLimit,
    })
  }))
)(Component)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/NewAgentStatus/AgentStatusAvatar/index.js